module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Ahi_Tuna.c7b46d29.jpg";